import { createSlice } from "@reduxjs/toolkit";
import { ProgrammaState } from "../types/state";
import { LOADING } from "../../../types";
import { setProgrammaError } from "../actions/setError";
import { setProgrammaData } from "../actions/setData";
import { addProgramma } from "../actions/add";
import { deleteProgramma } from "../actions/delete";
import { toggleProgrammaVisibility } from "../actions/toggleVisibility";
import { editProgramma } from "../actions/edit";

const initialState: ProgrammaState = {
  data: null,
  loading: LOADING.IDLE,
  error: null,
};

export const programmaSlice = createSlice({
  name: "programma",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(setProgrammaError, (state, { payload: error }) => {
        state.error = error;
        state.loading = LOADING.IDLE;
        state.data = null;
      })
      .addCase(setProgrammaData, (state, { payload: sponsors }) => {
        state.data = sponsors;
        state.error = null;
        state.loading = LOADING.IDLE;
      })
      .addCase(addProgramma.fulfilled, (state) => {
        state.error = null;
        state.loading = LOADING.IDLE;
      })
      .addCase(addProgramma.rejected, (state, { payload: error }) => {
        state.loading = LOADING.IDLE;
        state.error = error as string | null;
      })
      .addCase(addProgramma.pending, (state) => {
        state.loading = LOADING.PENDING;
        state.error = null;
      })
      .addCase(editProgramma.fulfilled, (state) => {
        state.error = null;
        state.loading = LOADING.IDLE;
      })
      .addCase(editProgramma.rejected, (state, { payload: error }) => {
        state.loading = LOADING.IDLE;
        state.error = error as string | null;
      })
      .addCase(editProgramma.pending, (state) => {
        state.loading = LOADING.PENDING;
        state.error = null;
      })
      .addCase(deleteProgramma.fulfilled, (state) => {
        state.error = null;
        state.loading = LOADING.IDLE;
      })
      .addCase(deleteProgramma.rejected, (state, { payload: error }) => {
        state.loading = LOADING.IDLE;
        state.error = error as string | null;
      })
      .addCase(deleteProgramma.pending, (state) => {
        state.loading = LOADING.PENDING;
        state.error = null;
      })
      .addCase(toggleProgrammaVisibility.fulfilled, (state) => {
        state.error = null;
        state.loading = LOADING.IDLE;
      })
      .addCase(
        toggleProgrammaVisibility.rejected,
        (state, { payload: error }) => {
          state.loading = LOADING.IDLE;
          state.error = error as string | null;
        },
      )
      .addCase(toggleProgrammaVisibility.pending, (state) => {
        state.loading = LOADING.PENDING;
        state.error = null;
      });
  },
});
